import React, { lazy, Suspense } from "react";
import { motion } from "framer-motion";
import { HomePageSEO } from "../../components/SEO/SEOHead";
import { useLanguage } from "../../context/LanguageContext";
import Hero from "../../components/sections/Hero";

// Lazy load below-fold sections to reduce initial bundle
const LandingPart2 = lazy(() => import("../../components/sections/BlackSection"));
const LandingPart3New = lazy(() => import("../../components/sections/LandingPart3New"));
const LandingPart4 = lazy(() => import("../../components/sections/LandingPart4"));
const LandingPart5 = lazy(() => import("../../components/sections/LandingPart5"));
const Testimonials = lazy(() => import("../../components/sections/Testimonials"));
const ScrollAnimationSection = lazy(() => import("../../components/sections/ScrollAnimationSection"));
const FeaturedBelt = lazy(() => import("../../components/sections/FeaturedBelt"));
const Footer = lazy(() => import("../../components/layout/Footer"));
const ProductRequestForm = lazy(() => import("../../components/ProductRequestForm"));

// Heavy deps: Three.js, GSAP shaders, @paper-design/shaders-react - lazy load aggressively
const CombinedBackground = lazy(() => import("../../components/ui/combined-background").then(m => ({ default: m.CombinedBackground })));
const ShaderBackgroundSection = lazy(() => import("../../components/sections/ShaderBackgroundSection"));

const SectionFallback = () => <div style={{ minHeight: "50vh" }} />;

const LandingPage = ({ animationState, isAuthRoute }) => {
  const { language } = useLanguage();

  return (
    <motion.div
      key="home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
    <HomePageSEO language={language} />
    {/* Initial Animation - KEEP THIS */}
    {(animationState === "initial" || animationState === "firstText" || animationState === "secondText" || animationState === "creditText" || animationState === "finalText") && (
      <div className={`animation-container ${animationState === "finalText" ? "exiting" : ""}`}>
      <div className={`text-animation first-text ${animationState === "firstText" ? "visible" : ""} ${animationState === "secondText" || animationState === "creditText" || animationState === "finalText" ? "exiting" : ""}`}>
          {!isAuthRoute && "مثل ما نیستا!"}
      </div>
      <div className={`text-animation second-text ${animationState === "secondText" ? "visible" : ""} ${animationState === "creditText" || animationState === "finalText" ? "exiting" : ""}`}>
        {!isAuthRoute && "LAVVISSA"}
      </div>
      <div className={`text-animation credit-text ${animationState === "creditText" ? "visible" : ""} ${animationState === "finalText" ? "exiting" : ""}`}>
        {!isAuthRoute && "By Sajad Abdolvandi"}
      </div>
    </div>
    )}

    {/* Site Content - Only Hero (first fullscreen video) is active */}
    <div className={`site-content ${animationState === "finalText" || animationState === "navbarVisible" ? "visible" : ""}`}>
      <div className="main-content">
        {/* Hero Section - First Fullscreen Video - KEEP THIS */}
        <div data-surface="light">
          <Hero animationState={animationState} />
        </div>
        
        {/* OLD LANDING PAGE SECTIONS - TEMPORARILY COMMENTED OUT (PRESERVED FOR FUTURE USE) */}
        {/* 
        <div data-surface="dark">
          <FeaturedBelt />
        </div>
        <div data-surface="light">
          <WhatWeDo />
        </div>
        <div data-surface="dark">
          <BrandShowcase />
        </div>
        <div data-surface="dark">
          <InstagramFeed />
        </div>
        <div data-surface="dark">
          <Testimonials />
        </div>
        <div data-surface="dark">
          <FeaturedProducts />
        </div>
        <div data-surface="dark">
          <Categories />
        </div>
        <WeeklyPicks />
        <div data-surface="dark">
          <PromoCards />
        </div>
        <div data-surface="dark">
          <FeaturedBlogPosts />
        </div>
        <div data-surface="dark">
          <NewsletterSignup />
        </div>
        <SiteFooter />
        */}
      </div>
    </div>

    {/* Below-fold sections - lazy loaded with Suspense */}
    {(animationState === "finalText" || animationState === "navbarVisible") && (
      <Suspense fallback={<SectionFallback />}>
        <LandingPart2 />
        <LandingPart3New />
        <LandingPart4 />
        <Testimonials />
        <LandingPart5 />
        <ScrollAnimationSection />
        <FeaturedBelt />

        {/* Heavy sections: Three.js + shader backgrounds */}
        <section className="fullscreen-section">
          <CombinedBackground
            shaderText="مثل ما نیستا!"
            pathsTitle="LAVVISSA"
          />
        </section>
        <section className="fullscreen-section">
          <ShaderBackgroundSection />
        </section>
        <section className="fullscreen-section" id="contact">
          <ProductRequestForm />
        </section>
        <section className="fullscreen-section">
          <Footer />
        </section>
      </Suspense>
    )}
  </motion.div>
  );
};

export default LandingPage;
